/**
 * Application URL and tenant resolution.
 *
 * Extracted from the barrel file to break circular dependencies —
 * internal modules (core.utils, core.effects, core.reducer) import
 * from here instead of the barrel.
 */

/**
 * To set APP URL
 */
function resolveAppUrl(): string | null {
  if (sessionStorage.getItem("isEmulated")) {
    return sessionStorage.getItem("emulatedURL")
  }
  if (window.location.hostname !== "localhost") {
    return window.location.origin
  }
  // Read from cookie (set by devtool on localhost)
  const match = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("platform-url="))
  if (match) {
    return decodeURIComponent(match.split("=").slice(1).join("=").trim())
  }
  return null
}

export const APP_URL = resolveAppUrl()

/**
 * To set APP Tenant.
 */
export const APP_TENANT = `${APP_URL?.split(".")[0]?.split("//")[1]}.`

/**
 * Resolve the current deployment environment from the host name.
 */
export const getEnvironment = () => {
  const hostname = APP_URL
    ? new URL(APP_URL).hostname
    : window.location.hostname
  const url = hostname.split(".").slice(1).join(".")
  if (url.includes("dev")) {
    return "dev"
  } else if (url.includes("qa")) {
    return "qa"
  } else if (url.includes("trial")) {
    return "trial"
  } else {
    return "prod"
  }
}

/**
 * @legacy Misspelled alias — kept until Insights migrates to getEnvironment().
 */
export const getEnvionment = getEnvironment
